import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCYIHHYEddofKluGTFzzZUsNIL5GBjEWME",
  authDomain: "sitsmart-d34a2.firebaseapp.com",
  databaseURL: "https://sitsmart-d34a2-default-rtdb.firebaseio.com",
  projectId: "sitsmart-d34a2",
  storageBucket: "sitsmart-d34a2.firebasestorage.app",
  messagingSenderId: "314498377828",
  appId: "1:314498377828:web:bc49b4ff2544f5f0679771",
  measurementId: "G-QTVNTYH0FB"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);       // Realtime Database
export const storage = getStorage(app);   // Firebase Storage
export default app;
